import React from "react";
import { Flex, Loader } from "@mantine/core";

interface PageLoaderProps {
  size?: number | string;
  mih?: number | string;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ size = 48, mih = "60vh" }) => (
  <Flex w="100%" justify="center" align="center" mih={mih}>
    <Loader size={size} />
  </Flex>
);

export default PageLoader;
